export const physical = [
  {
    name: "record",
    label: "Запись в офис",
    progress: true,
    type: "stepper",
    skip: true
  },
  {
    name: "services",
    label: "Выбор услуги",
    progress: false
  },
  {
    name: "form",
    label: "Заполнение формы",
    progress: true,
    type: "stepper",
    skip: true
  },
  {
    name: "varification",
    label: "Проверка"
  },
  {
    name: "pay",
    label: "Оплата",
    progress: false
  },
  {
    name: "success",
    label: "Готово"
  }
];

export const representative = [
  {
    name: "record",
    label: "Запись в офис",
    progress: true,
    type: "stepper",
    skip: true
  },
  {
    name: "representative-success",
    label: "Завершение"
  },
  {
    name: "success",
    label: "Готово"
  }
];
